import React from 'react';
import {
  Grid
} from '@material-ui/core';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import RegisteredEmploymentHistoryDisabledFields from "./RegisteredEmploymentHistoryDisabledFields";

const useStyles = makeStyles((theme) => ({
  root: {},
  fieldsRow: {
    marginBottom: '12px',
  },
  inputWithAssociationLink: {
    position: 'relative',
  },
  associationLink: {
    position: 'absolute',
    top: '-10px',
    right: '10px',
    cursor: 'pointer',
    decoration: 'none',
    '&:hover': {
      decoration: 'none',
    }
  }
}))

const RegisteredEmploymentHistoryFields  = (props) => {
  const classes = useStyles();

    const { id, attributes, _destroy } = props.employment;

    return (
      <React.Fragment>
        {_destroy ? null : (
          <Grid container spacing={3} key={id} className={classes.fieldsRow}>
          <RegisteredEmploymentHistoryDisabledFields attributes={attributes} />
            <Grid
              item
              md={3}
              xs={12}
            >
            </Grid>
          </Grid>
        )}
      </React.Fragment>
    )
}

RegisteredEmploymentHistoryFields.propTypes = {
  className: PropTypes.string,
  employment: PropTypes.object,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
};

export default RegisteredEmploymentHistoryFields;
